export default __webpack_public_path__ + "static/bg-page-community-forum-fa2f34563837eadb69f117f0557c2a19.jpg";